var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isValidElement, useState, Fragment } from 'react';
import { Card, CardExpandableContent, CardHeader, CardTitle, Divider, Flex, FlexItem, } from '@patternfly/react-core';
import { createUseStyles } from 'react-jss';
export const MultiContentCardDividerVariant = {
    left: 'left',
    right: 'right'
};
export const isCardWithProps = (card) => !!card && !isValidElement(card);
const useStyles = createUseStyles({
    cardTitle: {
        fontSize: 'var(--pf-t--global--font--size--heading--h3)',
    }
});
const MultiContentCard = (_a) => {
    var { cards = [], isToggleRightAligned = false, actions, toggleText, toggleContent, withDividers = false, isExpandable = false, defaultExpanded = true, ouiaId = 'MultiContentCard' } = _a, props = __rest(_a, ["cards", "isToggleRightAligned", "actions", "toggleText", "toggleContent", "withDividers", "isExpandable", "defaultExpanded", "ouiaId"]);
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);
    const classes = useStyles();
    const onExpand = () => {
        setIsExpanded(!isExpanded);
    };
    const renderCards = (cards, withDividers) => (_jsx(Flex, { alignSelf: { default: 'alignSelfStretch' }, alignItems: { default: 'alignItemsStretch' }, children: cards.map((card, index) => (_jsxs(Fragment, { children: [index > 0 && isCardWithProps(card) && card.dividerVariant === MultiContentCardDividerVariant.left && (_jsx(Divider, { orientation: { md: 'vertical' }, inset: { default: 'inset3xl' } })), _jsx(FlexItem, { flex: { default: 'flex_1' }, "data-ouia-component-id": `${ouiaId}-content-${index}`, children: isCardWithProps(card) ? card.content : card }, `card-${index}`), (index + 1 < cards.length && (withDividers || isCardWithProps(card) && card.dividerVariant === MultiContentCardDividerVariant.right)) && (_jsx(Divider, { orientation: { md: 'vertical' }, inset: { default: 'inset3xl' } }))] }, `card-${index}`))) }));
    return (_jsxs(Card, Object.assign({ isExpanded: isExpanded, ouiaId: ouiaId }, props, { children: [isExpandable && (_jsx(CardHeader, { "data-ouia-component-id": `${ouiaId}-header`, onExpand: onExpand, isToggleRightAligned: isToggleRightAligned, toggleButtonProps: {
                    'aria-label': 'Details',
                    'aria-expanded': isExpanded
                }, actions: { actions }, children: toggleText ? _jsx(CardTitle, { component: "h3", className: classes.cardTitle, "data-ouia-component-id": `${ouiaId}-title`, children: toggleText }) : toggleContent })), isExpandable ? _jsx(CardExpandableContent, { "data-ouia-component-id": `${ouiaId}-expandable-content`, children: renderCards(cards, withDividers) }) : renderCards(cards, withDividers)] })));
};
export default MultiContentCard;
